import { getProfile } from "~/composables/profile-data";

export const useProfileStore = defineStore("profileStore", () => {
  const profile = ref(null);

  async function getData(locale:string) {
    profile.value = await getProfile(locale);
  }

  return { profile, getData };
});
